export default __webpack_public_path__ + "static/media/iconeInlcuirProvedorMaior.f991eded.png";